
import Alpine from 'alpinejs';
import AsyncForm from './components/async-form';
import Blueprint from './components/blueprint'
import Carousel from './components/carousel';
import HeaderVideo from './components/header-video';
import MapAside from './components/map-aside';
import ShowSold from './components/show-sold'
import TextareaAutoheight from './components/textarea-autoheight';

window.Alpine = Alpine;

Alpine.data('asyncForm', AsyncForm);
Alpine.data('blueprint', Blueprint);
Alpine.data('carousel', Carousel);
Alpine.data('headerVideo', HeaderVideo);
Alpine.data('mapAside', MapAside);
Alpine.data('showSold', ShowSold);
Alpine.data('textareaAutoheight', TextareaAutoheight);

Alpine.start();
